interface MiniGaugeProps {
  value: number;
  limit: number;
  width?: number;
  /** Tooltip override; defaults to "value/limit (pct%)". */
  title?: string;
}

/**
 * Small horizontal gauge. Auto-tones at 0.7 (warn) and 0.9 (danger).
 */
export function MiniGauge({ value, limit, width = 64, title }: MiniGaugeProps) {
  if (limit <= 0) {
    return (
      <span
        className="minigauge minigauge--empty"
        style={{ width }}
        title={title ?? "no limit"}
      />
    );
  }
  const ratio = Math.max(0, Math.min(1.05, value / limit));
  const pct = Math.round(ratio * 100);
  const tone = ratio >= 0.9 ? "danger" : ratio >= 0.7 ? "warn" : "ok";
  return (
    <span
      className={`minigauge minigauge--${tone}`}
      style={{ width }}
      title={title ?? `${value.toFixed(2)} / ${limit.toFixed(2)} (${pct}%)`}
    >
      <span className="minigauge__fill" style={{ width: `${Math.min(100, ratio * 100)}%` }} />
    </span>
  );
}
